import { FieldBase, FieldBaseParam, FieldSettings } from './field-base';

export interface ChoiceValue {
  choices?: number;
  selections?: {
    score: number;
    label: string;
  }[];
}

export interface DynamicChoicesSettings extends FieldSettings {
  choice?: ChoiceValue;
}

export class FieldDynamicChoices extends FieldBase<ChoiceValue> {
  override controlType = 'dynamic-choices';

  constructor(options: FieldBaseParam<ChoiceValue> = {}) {
    super(options);
    this.settings = (options.settings as DynamicChoicesSettings) ?? {};
  }
}
